var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_690_3638",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_690_3638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 19.5312V0.703112H15.7656C16.1648 0.703112 16.5481 0.861642 16.8306 1.14449C17.113 1.42686 17.2719 1.80983 17.2719 2.20939V18.025C17.2719 18.4245 17.113 18.8075 16.8306 19.0899C16.5481 19.3727 16.1648 19.5312 15.7656 19.5312H0.703125Z",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 19.5312V0.703111",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2957 6.72814H20.2832V15.8952C20.2832 17.2587 20.8247 18.5669 21.7891 19.5312H21.7895C22.7538 18.5669 23.2957 17.2587 23.2957 15.8952V6.72814Z",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2957 2.20959C23.2957 1.81007 23.1368 1.4271 22.8544 1.14468C22.572 0.861883 22.1886 0.703352 21.7895 0.703352C20.9573 0.703352 20.2832 1.37774 20.2832 2.20959V3.71582H23.2957V2.20959Z",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2852 6.72852H23.2977V3.716H20.2852V6.72852Z",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.741 19.5313V23.2969L8.23477 22.5438L6.72849 23.2969V19.5313H9.741Z",
    stroke: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.74eba41947aeb831c48011da5e60d4c4.svg";
export { ForwardRef as ReactComponent };